import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
  fontWeight,
} from '../../styles/variables.style';

export const subHeading = css`
  font-family: ${fontFamily.fredoka};
  font-size: 28px;
  margin: 0 0 28px;

  &::after {
    content: '';
    display: block;
    height: 5px;
    width: 100px;
    border-radius: 5px;
    margin: 0 auto;
    background: ${appColors.yellow};
  }

  @media (min-width: ${breakpoints.md.up}) {
    font-size: 36px;
    margin-bottom: 42px;
  }
`;

export const featuresSection = css`
  margin-bottom: 24px;

  @media (min-width: ${breakpoints.lg.up}) {
    margin-bottom: 100px;
  }
`;

export const features = css`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -18px;
`;

export const featureItem = css`
  padding: 0 18px;
  flex: 0 0 100%;
  margin-bottom: 36px;

  @media (min-width: ${breakpoints.md.up}) {
    flex: 0 0 50%;
  }

  @media (min-width: ${breakpoints.lg.up}) {
    flex: 0 0 25%;
    margin-bottom: 0;
  }
`;

export const featureInner = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 20px 30px;
  text-align: center;
  border: 2px solid var(--base-color);
  border-radius: 10px;
`;

export const featureImg = css`
  width: 90px;
  height: 90px;
  object-fit: contain;
  margin-bottom: 20px;
`;

export const featureTitle = css`
  font-size: 20px;
  margin: 0 0 20px;
  text-transform: uppercase;
  color: var(--base-color);
  font-family: ${fontFamily.fredoka};
`;

export const featureLine = css`
  margin: 0 0 20px;
`;

export const featureBtn = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 206px;
  margin: auto auto 0;
  height: 46px;
  border: 1px solid transparent;
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  border-radius: 10px;
  background-color: var(--base-color);
  color: ${appColors.white};
  font-weight: ${fontWeight.semiBold};

  &:hover {
    color: ${appColors.white};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;
